import MuiInputBase, { type InputBaseProps as MuiInputBaseProps } from "@mui/material/InputBase";

export type InputProps = MuiInputBaseProps;

export function Input({ ...props }: InputProps) {
  return <MuiInputBase {...props} />;
}
